/* eslint-disable import/no-unresolved */
import { lazy, useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import 'ol/ol.css';
import './style.css';
import { Map, View } from 'ol';
import { LineString } from 'ol/geom';
import TileLayer from 'ol/layer/Tile';
import { Draw, Snap } from 'ol/interaction';
import { createBox } from 'ol/interaction/Draw';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import GeoJSON from 'ol/format/GeoJSON';
import { intersects as intersectsExtent } from 'ol/extent';
import { useGeographic, transform } from 'ol/proj';
import { DataService } from '../../config/dataService/dataService_yerbis';
import { Style, Stroke, Fill, Circle as CircleStyle } from 'ol/style';
import { defaults as defaultControls } from 'ol/control';
// import ProjeCalismaRenderModal from './ProjeCalismaRenderModal';
// import ProjeDetayProvider from './overview/contextApi/ProjeDetayProvider';
import OLTB from '../../lib/oltb/js/oltb';
import { getLength } from 'ol/sphere';
import { MenuRead } from '../../redux/menuCalismaSayilari/actionCreator';
import { LayerManager } from '../../lib/oltb/js/toolbar-managers/layer-manager/layer-manager';
import { Tile } from 'ol/layer';
import { OSM, XYZ } from 'ol/source';
import YerbisConstants from '../../constants/yerbisConstants';
// import { GlobalContext } from './overview/contextApi/GlobalContext';
import { useProjeDetay } from '../../hooks/useProjeDetay';
// import UserInfo from './UserInfo';
// import ProjeAlanGoster from './ProjeAlanGoster';
import ROLLER from '../../constants/roleConstant';
import { useAuth } from '../../hooks/useAuth';
import mapkey from '../../config/map/map-key';
import { bbox as bboxStrategy } from 'ol/loadingstrategy';
import NotificationHelper from '../../utility/notificationHelper';
import Overlay from 'ol/Overlay';
import { SpinerCustomStyle } from '../styled';
import { Spin, message } from 'antd';

useGeographic();

const LayerManagerComponent = lazy(() => import('./LayerManagerAFA'));

function AfetVeriAnalizi() {
  const { hasRoles } = useAuth();
  const alanGosterButonuIcinYetkisiVarmi = hasRoles([
    ROLLER.ADMIN,
    ROLLER.SUBE_MUDURU,
    ROLLER.KAMU_MUHENDISI,
    ROLLER.CEVRE_VE_SEHIRCILIK_MUHENDISI,
    ROLLER.KOMISYON,
    ROLLER.KOMISYON_UYESI,
    ROLLER.KOMISYON_YEDEK_UYESI,
    ROLLER.UYGULAMA_YONETICISI,
    ROLLER.IL_SUBE_MUDURU,
    ROLLER.BAKANLIK_DAIRE_BASKANI,
    ROLLER.GENEL_MUDUR,
    ROLLER.GENEL_MUDUR_YARDIMCISI,
    ROLLER.IL_MUDUR_YARDIMCISI,
    ROLLER.IL_MUDURU,
  ]);

  const { setProjeDetay } = useProjeDetay();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const [map, setMap] = useState(null);
  const [type, setType] = useState(null);
  const { id } = useParams();
  const mapRef = useRef();
  const drawRef = useRef(null);
  const snapRef = useRef(null);
  const [features, setFeatures] = useState([]);
  const [proje, setProje] = useState({});
  const sourceRef = useRef(new VectorSource());
  const [modalVisible, setModalVisible] = useState(false);
  const [alanGosterModalData, setalanGosterModalData] = useState({
    visible: false,
    feature: null,
    calismaTurleriCheckedIds: [],
    planTurleriCheckedIds: [],
  });
  const [modalData, setModalData] = useState({ proje: null, coordinates: null, calismaTuru: null });
  const [mousePosition, setMousePosition] = useState(null);
  const [initialCenter, setInitialCenter] = useState(null);
  const [refresh, setRefresh] = useState(false);
  const TR_EXTENT_4326 = [25.6, 35.7, 45.1, 42.3];
  const MIN_ZOOM = 10;

  // const { setSharedState, setHendekModalData } = useContext(GlobalContext);

  const { atlasApiKey: keyAzure } = mapkey;

  const fetchData = async () => {
    try {
      const response = await DataService.post('/Proje/ProjeDetay', { projeIdStr: id });
      // if (response?.data?.errorMessages?.length > 0) {
      //   navigate('/error');
      //   return;
      // }
      await DataService.post('/Proje/ProjeRead', { projeIdStr: id });
      dispatch(MenuRead());
      setProje(response?.data);
      setProjeDetay(response?.data);
      setFeatures(response?.data?.model?.geometry);
      document.title = response?.data?.model?.proje?.barkod_no
        ? `Proje: ${response?.data?.model?.proje?.barkod_no}`
        : document.title;
    } catch {
      /* empty */
    }
  };

  useEffect(() => {
    // fetchData();
  }, []);

  // useEffect(() => {
  //   fetchData();
  // }, [refresh]);

  const handleDrawEndUIReactionAlanGoster = (feature, calismaTurleriCheckedIds, planTurleriCheckedIds) => {
    setalanGosterModalData({
      visible: true,
      feature,
      calismaTurleriCheckedIds,
      planTurleriCheckedIds,
    });
  };

  useEffect(() => {
    if (mapRef.current) {
      return;
    }

    // 1) VectorSource: BBOX + minZoom + zoom/res parametreleri
    sourceRef.current = new VectorSource({
      format: new GeoJSON(),
      strategy: bboxStrategy,
      loader: async (extent, resolution, projection) => {
        const z = mapRef.current?.getView()?.getZoom?.() ?? 0;
        if (z < MIN_ZOOM) return;

        // Ekrandaki extent TR ile kesişiyor mu?
        if (!intersectsExtent(extent, TR_EXTENT_4326)) {
          return;
        }

        const params = {
          bbox: extent.join(','),
          zoom: String(Math.round(z)),
          res: String(resolution),
          limit: '5000',
        };

        setLoading(true);
        const response = await DataService.post('AfetVeriAnalizi/AlanGoster', params);
        if (!response?.data?.isSuccess) {
          setLoading(false);
          NotificationHelper.setResponseNotifications(response);
          // İstek başarısızsa aynı extent tekrar istenebilsin:
          // @ts-ignore (OL private API olabilir; gerek görmezsen çıkar)
          // if (source.removeLoadedExtent) source.removeLoadedExtent(extent);
          return;
        }

        const fc = response?.data?.model; // Controller JSON nesne olarak döndürüyor
        if (!fc) return;

        const fmt = new GeoJSON();
        const feats = fmt.readFeatures(fc, {
          dataProjection: 'EPSG:4326', // server çıktısı 4326
          featureProjection: projection, // view projeksiyonu (sende 4326)
        });

        message.success(`Alanda ${feats.length} adet kayıt bulundu`, 1);

        // Aynı id'li feature tekrar gelirse replace etmek isteyebilirsin:
        feats.forEach((f) => {
          const ids = f.getId();
          if (ids != null) {
            const existing = sourceRef.current.getFeatureById(ids);
            if (existing) sourceRef.current.removeFeature(existing);
            sourceRef.current.addFeature(f);
          } else {
            sourceRef.current.addFeature(f);
          }
        });

        setLoading(false);
      },
    });

    const vector = new VectorLayer({
      source: sourceRef.current,
      style: (() => {
        // Style cache (performans için tek kez oluştur)
        const pointStyle = new Style({
          image: new CircleStyle({
            radius: 7,
            fill: new Fill({ color: 'rgba(255, 0, 0, 0.8)' }),
            stroke: new Stroke({ color: '#ffcc33', width: 2 }),
          }),
        });

        const lineStyle = new Style({
          stroke: new Stroke({
            color: '#ff0000', // kalın mavi
            // color: '#0066ff', // kalın mavi
            width: 4,
          }),
        });

        const polygonStyle = new Style({
          stroke: new Stroke({
            color: '#0066ff', // kırmızı dış çizgi
            width: 2,
          }),
          fill: new Fill({
            color: 'rgba(255, 255, 0, 0.35)', // sarı iç dolgu (biraz şeffaf)
          }),
        });

        // Style selector
        return (feature) => {
          const types = feature.getGeometry().getType();
          if (types === 'Point' || types === 'MultiPoint') return pointStyle;
          if (types === 'LineString' || types === 'MultiLineString') return lineStyle;
          if (types === 'Polygon' || types === 'MultiPolygon') return polygonStyle;
          // GeometryCollection vs. durumlarda varsayılanı çizgi gibi yap
          return lineStyle;
        };
      })(),
    });

    // Haritayı oluştur
    mapRef.current = new Map({
      target: 'map',
      // layers: [vector],
      view: new View({
        projection: 'EPSG:4326',
        // extent: TR_EXTENT_4326,
        // center: [32.75162772729545, 39.911894772405866],
        center: TR_EXTENT_4326,
      }),
      controls: defaultControls({ attribution: false, zoom: false, rotate: false }),
    });

    LayerManager.addMapLayers(
      [
        {
          id: '97485b21-6a9d-48fb-9838-645543660dac',
          name: 'Google Haritalar',
          layer: new TileLayer({
            preload: Infinity,
            source: new XYZ({
              url: `https://mt1.google.com/vt/lyrs=m@113&hl=en&&x={x}&y={y}&z={z}`,
            }),
            visible: false,
          }),
        },
        {
          id: '97485b21-6a9d-48fb-9838-645543661dac',
          name: 'Google Uydu',
          layer: new TileLayer({
            preload: Infinity,
            source: new XYZ({
              url: `https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}&s=Ga`,
            }),
            visible: false,
          }),
        },
        {
          id: '7b5399a8-9e57-4304-a233-cdf363c8ed93',
          name: 'Open Street Map',
          layer: new Tile({
            source: new OSM({
              crossOrigin: 'anonymous',
            }),
            visible: false,
          }),
        },
        {
          id: '97485b21-6a9d-48fb-9838-645543648daa',
          name: 'ArcGIS World Topo',
          layer: new Tile({
            source: new XYZ({
              crossOrigin: 'anonymous',
              attributions:
                'Tiles © <a href="https://services.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer">ArcGIS</a>',
              url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Topo_Map/MapServer/tile/{z}/{y}/{x}',
            }),
            visible: false,
          }),
        },
      ],
      {
        isSilent: true,
        disableMapLayerEditButton: true,
        disableMapLayerDeleteButton: true,
      },
    );

    // --- POPUP OVERLAY ---
    const container = document.getElementById('popup');
    const closer = document.getElementById('popup-closer');
    const content = document.getElementById('popup-content');

    const popup = new Overlay({
      element: container,
      autoPan: { animation: { duration: 250 } },
      stopEvent: true,
      // offset: [0, -12], // iğnenin biraz üstünde dursun
    });

    mapRef.current.addOverlay(popup);

    closer.addEventListener('click', (e) => {
      e.preventDefault();
      popup.setPosition(undefined);
      closer.blur();
    });

    // Küçük yardımcı: HTML kaçış (XSS’e karşı)
    const esc = (v) =>
      String(v ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');

    // İstersen URL’leri linke çevir (sadece http/https)
    const linkify = (v) => {
      const s = String(v ?? '');
      return /^https?:\/\//i.test(s)
        ? `<a href="${esc(s)}" target="_blank" rel="noopener noreferrer">${esc(s)}</a>`
        : esc(s);
    };

    // Feature tıklama
    mapRef.current.on('singleclick', (evt) => {
      // Sadece bizim vector layer’dan feature bul
      const feature = mapRef.current.forEachFeatureAtPixel(
        evt.pixel,
        (f) => f,
        { layerFilter: (l) => l === vector }, // vector senin VectorLayer referansın
      );

      if (!feature) {
        popup.setPosition(undefined);
        return;
      }

      const prps = feature.getProperties();
      // Geometry objesini ayıkla (props.geometry olursa tabloyu kirletmesin)
      const { geometry, ...p } = prps;

      // Gösterilecek alanlar:
      // id, name, kml_geom_type, description, visibility, folder_name, folder_description, folder_kml_path
      const rows = [
        ['ID', esc(feature.getId() ?? p.id)],
        ['Ad', esc(p.name)],
        ['Tür', esc(p.kml_geom_type ?? p.kml_type)],
        ['Açıklama', esc(p.desc)],
        ['Görünür', p.visibility === true ? 'Evet' : p.visibility === false ? 'Hayır' : ''],
        ['Klasör', esc(p.folder_name)],
        ['Klasör Açıklama', esc(p.folder_desc)],
        ['KML', linkify(p.folder_kmlpath)],
      ].filter(([, v]) => v !== '' && v != null);

      content.innerHTML = rows.length
        ? `<table>${rows.map(([k, v]) => `<tr><td>${k}</td><td>${v}</td></tr>`).join('')}</table>`
        : '<em>Özellik bulunamadı</em>';

      popup.setPosition(evt.coordinate);
    });

    // Hover’da el işareti (kullanıcı deneyimi)
    mapRef.current.on('pointermove', (evt) => {
      const hit = mapRef.current.hasFeatureAtPixel(evt.pixel, { layerFilter: (l) => l === vector });
      mapRef.current.getTargetElement().style.cursor = hit ? 'pointer' : '';
    });

    // Control
    // const scale = new Scale({});
    // mapRef.current.addControl(scale);
    // mapRef.current.addControl(scaleControl());

    mapRef.current.once('rendercomplete', () => {
      const view = mapRef.current.getView();
      view.fit(TR_EXTENT_4326, {
        size: mapRef.current.getSize(),
        padding: [32, 32, 32, 32],
      });

      LayerManager.addFeatureLayer({
        name: 'Çalışma Alanı',
        layer: vector,
      });
    });

    const tools = {};
    if (alanGosterButonuIcinYetkisiVarmi) {
      tools.AreaViewTool = {
        onDrawEndSuccess: handleDrawEndUIReactionAlanGoster,
      };
    }
    const oltb = new OLTB({
      map: mapRef.current,
      tools,
    });

    mapRef.current.addControl(oltb);

    // Mouse hareketlerini dinleme
    mapRef.current.on('pointermove', (evt) => {
      setMousePosition(evt.coordinate);
    });

    // minZoom altına inince vektör kaynağını temizle
    mapRef.current.getView().on('change:resolution', () => {
      if ((mapRef.current?.getView()?.getZoom() ?? 0) < MIN_ZOOM) {
        sourceRef.current?.clear();
      } else {
        // zoom tekrar eşik üstüne çıkarsa görünür alan için yeniden yükler
        sourceRef.current?.refresh();
      }
    });

    setMap(mapRef.current); // mapRef.current'i state olarak sakla
  }, []);

  const addInteractions = (drawType, isMulti, calismaTuru, isFayIzi) => {
    drawRef.current = new Draw({
      source: sourceRef.current,
      type: drawType,
      maxPoints: drawType === 'LineString' && !isMulti ? 2 : undefined,
      geometryFunction:
        drawType === 'Circle'
          ? (coordinates, geometry) => {
              if (!geometry) {
                geometry = createBox();
              }
              return geometry(coordinates);
            }
          : drawType === 'LineString' && !isMulti
          ? (coordinates, geometry) => {
              if (!geometry) {
                geometry = new LineString([]);
              }
              geometry.setCoordinates(coordinates.slice(0, 2)); // Sadece iki noktayı kullan
              return geometry;
            }
          : undefined,
    });

    drawRef.current.on('drawend', (event) => {
      const { feature } = event;

      const geometry = feature.getGeometry();
      const coordinates = geometry.getCoordinates();

      let length = 0;
      let aci = 0;

      if (geometry.getType() === 'LineString' && coordinates.length >= 2) {
        const transformedCoords = coordinates.map((coord) => transform(coord, 'EPSG:4326', 'EPSG:3857'));
        const transformedGeometry = geometry.clone();
        transformedGeometry.setCoordinates(transformedCoords);

        length = getLength(transformedGeometry);

        const bas = coordinates[0];
        const son = coordinates[1];

        const dx = son[0] - bas[0];
        const dy = son[1] - bas[1];

        const angleRad = Math.atan2(dy, dx);
        aci = (angleRad * 180) / Math.PI;

        if (aci < 0) {
          aci += 360;
        }
      }

      // Çizim tamamlandığında etkileşimleri kaldır ve fare imlecini geri döndür
      mapRef.current.removeInteraction(drawRef.current);
      mapRef.current.removeInteraction(snapRef.current);
      mapRef.current.getTargetElement().style.cursor = '';
      drawRef.current = null;
      snapRef.current = null;

      if (isFayIzi) {
        // Fay izi çiziminden sonra ana modalı da tekrar göster
        setModalVisible(false);
        // setSharedState(true);
        // setHendekModalData({ proje: proje?.model?.proje, coordinates, calismaTuru, aci, length });
      } else {
        setModalData({ proje: proje?.model?.proje, coordinates, calismaTuru, aci, length });
        setModalVisible(true);
      }

      setTimeout(() => {
        sourceRef.current.removeFeature(feature);
      }, 100);
    });

    mapRef.current.addInteraction(drawRef.current);

    snapRef.current = new Snap({ source: sourceRef.current });
    mapRef.current.addInteraction(snapRef.current);
  };

  const handleDraw = (drawType, isMulti, calismaTuru, isFayIzi = false) => {
    if (calismaTuru === YerbisConstants.CalismaTurleri.PaleosismolojiCalismasi) {
      setModalData({ proje: proje?.model?.proje, calismaTuru });
      setModalVisible(true);
      return;
    }
    console.log(calismaTuru);
    if (
      YerbisConstants.CalismaTurleri.AktifFay === calismaTuru ||
      YerbisConstants.CalismaTurleri.FaySakinimZonu === calismaTuru
    ) {
      setModalData({ proje: proje?.model?.proje, calismaTuru });
      setModalVisible(true);
      return;
    }

    if (drawRef.current) {
      mapRef.current.removeInteraction(drawRef.current);
      mapRef.current.removeInteraction(snapRef.current);
      drawRef.current = null;
      snapRef.current = null;
    }

    setType(drawType);
    mapRef.current.getTargetElement().style.cursor = 'crosshair';
    addInteractions(drawType, isMulti, calismaTuru, isFayIzi);
  };

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === 'Escape' && drawRef.current) {
        mapRef.current.removeInteraction(drawRef.current);
        mapRef.current.removeInteraction(snapRef.current);
        mapRef.current.getTargetElement().style.cursor = '';
        drawRef.current = null;
        snapRef.current = null;
      }
    };

    window.addEventListener('keydown', handleKeyDown);

    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, []);

  return (
    <>
      {loading && (
        <SpinerCustomStyle>
          <Spin />
        </SpinerCustomStyle>
      )}
      {/* <ModalSample
        modalData={modalData}
        visible={modalVisible}
        onCancel={() => {
          setModalVisible(false);
        }}
      /> */}
      {/* {modalVisible && (
        <ProjeCalismaRenderModal modalData={modalData} modalVisible={modalVisible} setModalVisible={setModalVisible} />
      )} */}
      <LayerManagerComponent
        modalDataLayerManager={modalData}
        projeBilgi={proje}
        onDraw={handleDraw}
        map={mapRef.current}
        bilgiYenile={() => {
          setRefresh((prev) => !prev);
        }}
        projeId={id}
      />

      {/* <UserInfo /> */}

      {/* <ProjeToolbar projeBilgi={proje} /> */}
      <div id="oltb" className="init-visible" />
      <div id="map" className="ol-full-screen map" />
      <div className="mouse-position">
        {mousePosition && `${mousePosition[1].toFixed(6)}, ${mousePosition[0].toFixed(6)}`}
      </div>
      <div id="popup" className="ol-popup">
        <a href="#" id="popup-closer" className="ol-popup-closer">
          ×
        </a>
        <div id="popup-content" />
      </div>

      {/* {alanGosterModalData?.visible && (
        <Modal
          title="Alan Göster"
          footer={false}
          width="95%"
          style={{
            top: 10,
          }}
          // footer={null}
          visible={alanGosterModalData?.visible}
          // onOk={handleOkRaporYeni}
          onCancel={() => {
            setalanGosterModalData({
              ...alanGosterModalData,
              visible: false,
            });
          }}
        >
          <ProjeAlanGoster olMap={map} params={alanGosterModalData} />
        </Modal>
      )} */}
    </>
  );
}

export default AfetVeriAnalizi;
